module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-4-en-CA-cd3d0153eea59f9c0a1702ac68227672.png";